import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "search-guild",
  class: "p-3"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-0" }, "Find your community on squadron!", -1)
const _hoisted_3 = ["validation-schema"]
const _hoisted_4 = { class: "flex flex-row chat-input gap-3" }
const _hoisted_5 = {
  id: "fullName-help",
  class: "p-error"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", null, "Search Results", -1)

import { GenericObject, configure, useForm } from 'vee-validate';
import { reactive } from 'vue';
import * as yup from 'yup';
import { GuildDto, ShortGuild } from '@/models/guild.model';
import axios from 'axios';
import apiConfig from "@/config/api";
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';


export default /*#__PURE__*/_defineComponent({
  __name: 'TheGuildExplore',
  setup(__props) {

const schema = yup.object({
  guildName: yup.string().min(3).required()
});

const { defineField, handleSubmit, errors } = useForm({
  validationSchema: schema,
});

const [guildName] = defineField('guildName');

const searchResults = reactive({
  guilds: [] as ShortGuild[]
});

configure({
  validateOnBlur: true,
  validateOnChange: false,
  validateOnInput: false,
  validateOnModelUpdate: false
})

const onSubmit = handleSubmit (async (values: GenericObject) => {
  try {
    const params = {
      searchTerm: values.guildName
    };
    console.log(params);

    const response = await axios.get(`${apiConfig.baseURL}/guild/search`, { params });
    console.log(response.data);
    searchResults.guilds = response.data.map((guild: GuildDto) => new ShortGuild(guild));
  } catch (error) {
    console.error(error);
  }
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("form", {
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args)), ["prevent"])),
      "validation-schema": _unref(schema)
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(InputText), {
          modelValue: _unref(guildName),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(guildName) ? (guildName).value = $event : null)),
          id: "guildName",
          type: "destextription",
          class: _normalizeClass({ 'p-invalid': _unref(errors).guildName })
        }, null, 8, ["modelValue", "class"]),
        _createVNode(_unref(Button), {
          type: "submit",
          label: "Search"
        })
      ]),
      _createElementVNode("small", _hoisted_5, _toDisplayString(_unref(errors).guildName), 1)
    ], 40, _hoisted_3),
    (searchResults.guilds.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchResults.guilds, (guild) => {
              return (_openBlock(), _createElementBlock("li", {
                key: guild.id
              }, [
                _createVNode(_component_router_link, {
                  to: { name: 'guild', params: { guildId: guild.id }}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(guild.name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})